import { render, staticRenderFns } from "./SystemMaintenance.vue?vue&type=template&id=56a09ac1&scoped=true&"
import script from "./SystemMaintenance.vue?vue&type=script&lang=js&"
export * from "./SystemMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./SystemMaintenance.vue?vue&type=style&index=0&id=56a09ac1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a09ac1",
  null
  
)

export default component.exports